export default __webpack_public_path__ + "static/media/drop_card_add_talent.7e9a238a.svg";